import Link from 'next/link';
import {
  FooterWrapper,
  List,
  ListItem,
  FooterContainer,
  TitleInfo,
  ContentSocialMedia,
  Box,
  BottomFooter,
  BottomFooterText,
  BottomFooterTCopyright,
  ScrollTopButton,
  ScrollTopButtonWrapper,
  LogoContainer,
} from './footer.style';
import { FOOTER_WIDGET } from 'common/data/SaasModern';
import { translation } from '../../../../translation/translation';
import Facebook from 'common/assets/image/logo/social/Facebook';
import XLogo from 'common/assets/image/logo/social/XLogo';
import Youtube from 'common/assets/image/logo/social/youtube';
import LinkedIn from 'common/assets/image/logo/social/LinkedIn';
import Discord from 'common/assets/image/logo/social/Discord';
import Envelope from 'common/assets/image/logo/social/Envelope';

const Footer = ({ locale }) => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  return (
    <FooterWrapper>
      <FooterContainer>
        {FOOTER_WIDGET.map((widget, index) => (
          <Box className="col" key={`footer-widget-${index}`}>
            <TitleInfo>{widget.title[locale]}</TitleInfo>
            <List>
              {widget.menuItems.map((item, index) => (
                <ListItem key={`footer-list-item-${index}`}>
                  <Link href={item.url} passHref legacyBehavior>
                    <a
                      target={item.blank ? '_blank' : '_self'}
                      className="ListItem"
                    >
                      {item.text[locale]}
                    </a>
                  </Link>
                </ListItem>
              ))}
            </List>
          </Box>
        ))}
      </FooterContainer>
      <BottomFooter>
        <ContentSocialMedia>
          <Link href="https://linkedin.com/company/swiftask" target="_blank">
            <LogoContainer>
              <LinkedIn />
            </LogoContainer>
          </Link>
       
          <Link href="https://x.com/swiftask_ai" target="_blank">
            <LogoContainer>
              <XLogo />
            </LogoContainer>
          </Link>
           <Link href="https://www.facebook.com/swiftask" target="_blank">
            <LogoContainer>
              <Facebook />
            </LogoContainer>
          </Link>
          <Link href="https://www.youtube.com/@Swiftask" target="_blank">
            <LogoContainer>
              <Youtube />
            </LogoContainer>
          </Link>
       
          <Link href="https://discord.gg/TpxmW8RbZa" target="_blank">
            <LogoContainer>
              <Discord />
            </LogoContainer>
          </Link>
          <Link href="mailto:contact@swiftask.ai" target="_blank">
            <LogoContainer>
              <Envelope />
            </LogoContainer>
          </Link>
        </ContentSocialMedia>
        <BottomFooterTCopyright>
          {translation.encrypt[locale]}
        </BottomFooterTCopyright>
        <BottomFooterText>
          Your trust is our priority. We are committed to protecting your
          personal data and respecting your privacy.
        </BottomFooterText>
        <ScrollTopButtonWrapper>
          <ScrollTopButton onClick={scrollToTop}>
            <svg viewBox="0 0 24 24">
              <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" />
            </svg>
          </ScrollTopButton>
        </ScrollTopButtonWrapper>
      </BottomFooter>
    </FooterWrapper>
  );
};

export default Footer;
